import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography } from '@mui/material';
import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';

interface FoodAdditionalDrawerHeaderProps {
    restaurantOfferStore: RestaurantOfferStore
}

const FoodAdditionalDrawerHeader: React.FC<FoodAdditionalDrawerHeaderProps> = observer(({ restaurantOfferStore }) => {
    const { orderFoodRequest } = restaurantOfferStore;

    if (orderFoodRequest === undefined) {
        return null;
    }

    const { food } = orderFoodRequest;

    return (
        <Box mb={2}>
            <Typography variant='h5' fontWeight={600}>{food.name}</Typography>
            <Typography variant='subtitle2'>{food.description}</Typography>
            <Typography variant='subtitle2'>{orderFoodRequest.note}</Typography>
        </Box>
    )
})

export default FoodAdditionalDrawerHeader;